import { anchorLink } from "./include/module";
import { stepSlider } from "./include/module";
import { visibleButton } from "./include/module";





(() => {

  anchorLink();

  stepSlider();

  visibleButton();

})();



// WEBPACK FOOTER //
// ./src/assets/js/script.js